export const ENV = {
  PRODUCTION: 'https://www.mawoopets.com',
  QA: 'https://mawoo-qa.vercel.app/',
  DEVELOPMENT: 'http://localhost:3000',
}

export const ROBOTS_META =
  process.env.NEXT_PUBLIC_ROOT_URL === ENV.PRODUCTION
    ? 'index, follow'
    : 'noindex, nofollow'

export const sideMenuIcons = [
  {
    src: '/reservations.svg',
    title: 'D-Applications',
    uri: '/admin/dog-applications',
    associateWith: '/admin/dog-applications/*',
  },
  {
    src: '/header/pet.svg',
    title: 'Take Me Home Submissions',
    uri: '/admin/puppynotifications',
    associateWith: '/admin/puppynotifications/*',
  },
  {
    src: '/gift.svg',
    title: 'Ambassador Program',
    uri: '/admin/ambassadors',
    associateWith: '/admin/ambassadors/*',
  },
  {
    src: '/header/pet.svg',
    title: 'Notify me forms',
    uri: '/admin/breed-notifications',
    associateWith: '/admin/breed-notifications/*',
  },
  {
    src: '/dashboard/admin/calc.svg',
    title: 'Price Calculator',
    uri: '/admin/price-calculator',
    associateWith: '/admin/price-calculator/*',
  },
  {
    src: '/dashboard.svg',
    title: 'Discounts',
    uri: '/admin/discounts',
    associateWith: '/admin/discounts/*',
  },
  {
    src: '/favorites.svg',
    title: 'Featured Puppies',
    uri: '/admin/landing-photos',
    associateWith: '/admin/landing-photos/*',
  },
  {
    src: '/header/pet.svg',
    title: 'Pets',
    uri: '/admin/pets',
    associateWith: '/admin/pets/*',
  },
  {
    src: '/dashboard.svg',
    title: 'Images',
    uri: '/admin/images',
    associateWith: '/admin/images/*',
  },
  {
    src: '/add-image.svg',
    title: 'State Covers',
    uri: '/admin/states-covers',
    associateWith: '/admin/states-covers/*',
  },
  {
    src: '/dashboard.svg',
    title: 'Cover Photos',
    uri: '/admin/breeds',
    associateWith: '/admin/breeds/*',
  },
  {
    src: '/reservations.svg',
    title: 'B-Applications',
    uri: '/admin/applications',
    associateWith: '/admin/applications/*',
  },
  {
    src: '/mail@2x.png',
    title: 'Breeder Emails',
    uri: '/admin/breeders',
    associateWith: '/admin/breeders/*',
  },
  {
    src: '/shipping/plane.svg',
    title: 'Transport Pricing',
    uri: '/admin/transport-pricing',
    associateWith: '/admin/transport-pricing/*',
  },
  {
    src: '/reservations.svg',
    title: 'Blacklist',
    uri: '/admin/blacklist',
    associateWith: '/admin/blacklist/*',
  },
]
